<template>
    <div class="bottom">
      <div class="bottom_top">
        <div class="bottom_o">
          <div class="bottom_logo">
            <img src="../assets/img/logo.png" />
          </div>
<!--          <div class="qq">-->
<!--            <img src="../assets/img/qq@2x.png" />-->
<!--            <span>190073259</span>-->
<!--          </div>-->
          <div class="tel">
            <img src="../assets/img/tel@2x.png" />
            <span>{{ this.assistForm.phone }}</span>
          </div>
          <div class="email">
            <img src="../assets/img/email@2x.png" />
            <span>{{ this.assistForm.email }}</span>
          </div>
          <div class="ewm">
            <img :src="ewmImg" />
          </div>
        </div>
      </div>
      <div class="bottom_t">
        <img src="../assets/img/beian.png" />
        <span @click="toGa">陕公网安备61019002001202号<i v-if="pageWidth > 1280">|</i></span>
        <span @click="toICP">陕ICP备20012057号<i>|</i></span>
        <span class="copyright">Copyright @ 2024 西安灵软信息技术有限公司</span>
      </div>
    </div>

</template>

<script>
  export default {
    name: "bottom",
    data() {
      return {
        pageWidth: 0,
        ewmImg: '',
        assistForm: {
          phone: '',
          email: '',
          zxPhone: '',
          qq: '',
          fwkhValue: '',
          rzzlValue: '',
          phoneZc: '',
          phoneZcTime: '',
          emailZc: '',
          emailZcTime: '',
          remoteZcTime: '',
          xcZc: '',
          aboutUs: ''
        },
      }
    },
    mounted() {
      this.pageWidth = document.documentElement.clientWidth
    },
    created() {
      this.getBannerQrCode()
    },
    methods: {
      // ICP备案
      toICP() {
        window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank')
      },
      // 公安备案
      toGa() {
        window.open('https://beian.mps.gov.cn/#/query/webSearch', '_blank')
      },
      // 获取二维码
      getBannerQrCode() {
        this.$API.InterfaceConfigurationPage._getBannerImgList({
          params: {
            type: 2
          }
        }).then(res => {
          if (res.success) {
            if (res.data.length >0) {
              this.ewmImg = res.data[0].path
            }
            this.getauxiliaryinfo()
          } else {
            this.$Message.info('系统错误')
          }
        }).catch(err => {
          console.log('获取失败===', err);
        });
      },
      // 获取辅助参数
      getauxiliaryinfo() {
        this.$API.InterfaceConfigurationPage._getauxiliaryinfo().then(res => {
          if (res.success) {
            if (res.data.length > 0) {
              res.data.forEach(item => {
                if (item.name == '电话') {
                  this.assistForm.phone = item.value
                }
                if (item.name == '邮箱') {
                  this.assistForm.email = item.value
                }
                if (item.name == '咨询电话') {
                  this.assistForm.zxPhone = item.value
                }
                if (item.name == 'WeChat') {
                  this.assistForm.qq = item.value
                }
                if (item.name == '服务客户') {
                  this.assistForm.fwkhValue = item.value
                }
                if (item.name == '软著专利资质') {
                  this.assistForm.rzzlValue = item.value
                }
                if (item.name == '电话支持') {
                  this.assistForm.phoneZc = item.value
                }
                if (item.name == '电话支持时间') {
                  this.assistForm.phoneZcTime = item.value
                }
                if (item.name == 'E-mail支持') {
                  this.assistForm.emailZc = item.value
                }
                if (item.name == 'E-mail支持时间') {
                  this.assistForm.emailZcTime = item.value
                }
                if (item.name == '远程支持时间') {
                  this.assistForm.remoteZcTime = item.value
                }
                if (item.name == '现场支持') {
                  this.assistForm.xcZc = item.value
                }
                if (item.name == '关于我们') {
                  this.assistForm.aboutUs = item.value
                }
              })
            }
          } else {
            this.$Message.info('系统错误')
          }
        }).catch(err => {
          console.log('获取失败===', err);
        });
      }
    }
  }
</script>

<style scoped lang="less">
  @import "../assets/css/footer.less";
</style>



// WEBPACK FOOTER //
// src/components/bottom.vue